import { ChangeEvent, FormEvent, useState } from "react";
import Button from "components/ui/Button";
import TextInput from "components/ui/TextInput";
import FrameBack from "../../images/frame_back.svg?react";
import MainLogo from "./../../images/main-logo.svg?react";
import UserIcon from "./../../images/person.svg?react";
import Spinner from "components/ui/Spinner";
import { signInSSO } from "../../services/users/auth";
import { ApiRequestError } from "services/errors";
import styles from "./SignInSSO.module.scss";
import { Link, useSearchParams } from "react-router-dom";
import { routes } from "pages/routes";
import { useTranslation } from "react-i18next";
import { trackEvent } from "services/productAnalytics";
import ApiErrorBanner from "components/ApiErrorBanner";

export default function SignInSSO() {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState(searchParams.get("email") || "");
  const [error, setError] = useState<unknown>(searchParams.get("error"));
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const response = await signInSSO(email);
      window.location.replace(response.redirect_url);
      trackEvent("sign_in_success");
    } catch (err) {
      setError(err);
      trackEvent("sign_in_error", {
        status: err instanceof ApiRequestError ? err.response?.status : undefined,
        error_code: err instanceof ApiRequestError ? err.errorCode : undefined,
      });
    } finally {
      setLoading(false);
    }
  };

  const onEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    setEmail(event.target.value);
  };

  return (
    <div className={styles.page}>
      <div className={styles.content}>
        <MainLogo />
        <div className={styles.header}>
          <UserIcon />
          <h1>{t("Auth.ssoForm.title")}</h1>
        </div>
        {loading && <Spinner className={styles.spinner} />}
        <ApiErrorBanner error={error} />
        <form onSubmit={event => void onSubmit(event)}>
          <div className={styles.formWrapper}>
            <TextInput
              label={t("Auth.ssoForm.emailLabel")}
              size="extra-large"
              name="email"
              placeholder="johnsmith@gmail.com"
              value={email}
              onChange={onEmailChange}
              disabled={loading}
            />
            <Button
              className={styles.button}
              size="large"
              type="submit"
              disabled={loading}
            >
              {t("Auth.nav.signIn")}
            </Button>
            <Link className={styles.link} to={routes.public.signIn.path()} replace>
              {t("Auth.ssoForm.backToSignIn")}
            </Link>
          </div>
        </form>
      </div>
      <FrameBack className={styles.frameBack} />
    </div>
  );
}
